import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function accountNumberReducer(state = initialState.accountNumber, action) {
  switch (action.type) {
    case types.SET_ACCOUNTNUMBER_LOCK:
      return Object.assign({}, state, {
        lockedId: action.lockedId,
      });
    case types.SET_UNSET_LOCK:
      return Object.assign({}, state, {
        locked: action.locked,
      });
    default:
      return state;
  }
}
